jQuery(function ($) {
	const MKIP_Scripts = {
		varInit() {
			this.notifications = $('.header-notifications');
			this.header = $('header');
			this.primary = $('#primary');
			this.document = $(document);
			this.mobile = $('.mobile');
			this.burger = $('.burger-btn');
			this.careerCurrentPage = 1;
			this.careerAnnouncementsCurrentPage = 1;
		},

		varResize() {
			window.notificationsShow = this.notifications.length ? true : false;
			window.notificationsHeight = this.notifications.innerHeight();
			if (window.notificationsShow) {
				this.mobile.css({
					top: window.notificationsHeight + 'px',
					height:
						$(window).innerHeight() - this.notifications.innerHeight() + 'px',
				});
			}
		},

		headerFixed() {
			let headerBottom = this.header.innerHeight();
			if (window.notificationsShow) {
				headerBottom = headerBottom + window.notificationsHeight;
			}
			const space = headerBottom + 150;
			if (this.document.scrollTop() > headerBottom) {
				this.header.addClass('fixed');
				this.primary.addClass('headerFixed');
				if (this.document.scrollTop() > space) {
					this.header.addClass('show');
				} else {
					this.header.removeClass('show');
				}
			} else {
				this.header.removeClass('fixed');
				this.primary.removeClass('headerFixed');
			}

			if (!this.header.hasClass('show') && this.mobile.hasClass('fixed')) {
				this.mobile.removeClass('fixed');
				this.burger.unbind('click');
				this.burger.click(function () {
					$('html, body').animate({ scrollTop: 0 }, 'fast');
					$('body').toggleClass('menu-open');
					$(this).toggleClass('active');
					$('.menu-mobile > .menu-item').removeClass('active sm');
				});
			} else if (
				this.header.hasClass('show') &&
				!this.mobile.hasClass('fixed')
			) {
				this.mobile.addClass('fixed');
				this.burger.unbind('click');
				this.burger.click(function () {
					$('body').toggleClass('menu-open');
					$(this).toggleClass('active');
					$('.menu-mobile > .menu-item').removeClass('active sm');
				});
			}
		},

		headerScripts() {
			if (!this.mobile.hasClass('fixed')) {
				this.burger.click(function () {
					$('html, body').animate({ scrollTop: 0 }, 'fast');
					$('body').toggleClass('menu-open');
					$(this).toggleClass('active');
					$('.menu-mobile > .menu-item').removeClass('active sm');
				});
			}

			const mobWrap = $('.mobile__wrap');
			const mobileMenuItem = $('.menu-mobile > .menu-item');
			mobileMenuItem.click(function () {
				const subMenu = $(this).find('.sub-menu');
				subMenu.click(function () {
					event.stopPropagation();
				});
				if ($(this).hasClass('active')) {
					mobileMenuItem.removeClass('sm');
					$(this).removeClass('active');
					mobWrap.animate({ scrollTop: 0 }, 'fast');
				} else {
					mobileMenuItem.addClass('sm');
					mobileMenuItem.removeClass('active');
					$(this).removeClass('sm');
					$(this).addClass('active');
				}
				const thisMenu = $(this);
				setTimeout(function () {
					const subMenuBottom =
						subMenu.offset().top + subMenu.get(0).scrollHeight;
					const documentBottom =
						$(document).scrollTop() + $(window).innerHeight();
					if (subMenuBottom > documentBottom && thisMenu.hasClass('active')) {
						mobWrap.animate(
							{
								scrollTop:
									subMenuBottom - documentBottom + 20 + mobWrap.scrollTop(),
							},
							'slow'
						);
					}
				}, 600);
			});

			$('.header__search-btn').click(function () {
				$('.header__search-btn').toggleClass('hide');
				$('.header__nav').toggleClass('hide');
				$('.header__eye').toggleClass('hide');
				$('.header__lang').toggleClass('hide');
				if ($(window).width() < 575) {
					$('.header__logo').toggleClass('hide');
				}
				$('.header-search__block').toggleClass('open');
			});
			$('.header-mobile__search').click(function () {
				//$(".header-mobile__search").toggle();
				$('.header-mobile-search__block').toggleClass('open');
			});
			$('.header-mobile-search__close-popup').click(function () {
				$('.header-mobile-search__block').toggleClass('open');
			});
			$('.header-search__close-popup').click(function () {
				$('.header__search-btn').toggleClass('hide');
				$('.header-search__block').toggleClass('open');
				$('.header__nav').toggleClass('hide');
				$('.header__eye').toggleClass('hide');
				$('.header__lang').toggleClass('hide');
				if ($(window).width() < 575) {
					$('.header__logo').toggleClass('hide');
				}
			});
			$('.header-search__icon-popup-btn').click(function () {
				if ($('.search-form__input').val().length > 0) {
					$('.search-form--header').submit();
				}
			});
			$('.header-mobile-search__icon-popup-btn').click(function () {
				if ($('.search-mobile-form__input').val().length > 0) {
					$('.header-mobile-search__form').submit();
				}
			});
			$(
				'.search-form__submit:not(.accordion-search-form__submit)' &&
					'.search-form__submit:not(.legislation-search-form__submit)'
			).click(function () {
				if ($('.search-form-search-page__input').val().length > 0) {
					$('.search-page__form').submit();
				}
			});
			if ($('.search-form-search-page__input')) {
				$('.search-form-search-page__input').keyup(function () {
					if ($('.search-form-search-page__input').val().length > 0) {
						$(
							'.search-form__submit:not(.accordion-search-form__submit)'
						).removeClass('disable');
					} else {
						$(
							'.search-form__submit:not(.accordion-search-form__submit)'
						).addClass('disable');
					}
				});
			}

			// Vision
			let accessCount = 0;
			const accessCookie = $.cookie('access');
			if (accessCookie && accessCookie != 0) {
				$('body').addClass('access-' + accessCookie);
				accessCount = accessCookie;
			}
			$('.vision-item').click(function () {
				event.preventDefault();
				$(
					'.pojo-a11y-toolbar-link[data-action="' +
						$(this).data('action') +
						'"]'
				).trigger('click');
				if ($(this).data('action') === 'reset') {
					$('body').removeClass('access-' + accessCount);
					$.cookie('access', 0, { path: '/' });
					accessCount = 0;
				}
			});
			$('.vision-item-resize').click(function () {
				event.preventDefault();
				if ($(this).data('action') === 'resize-plus' && accessCount <= 1) {
					$('body').removeClass('access-' + accessCount);
					$('body').addClass('access-' + ++accessCount);
					$.cookie('access', accessCount, { path: '/' });
				}
				if ($(this).data('action') === 'resize-minus' && accessCount >= 1) {
					$('body').removeClass('access-' + accessCount);
					$.cookie('access', 0, { path: '/' });
					accessCount--;
					if (accessCount != 0) {
						$('body').addClass('access-' + accessCount);
						$.cookie('access', accessCount, { path: '/' });
					}
				}
			});
			if ($(window).width() < 1024) {
				$('.vision-btn').click(function () {
					$('.vision-list').toggleClass('show');
				});

				$(document).click(function (e) {
					if ($(e.target).parents('.vision-btn').length === 0) {
						$('.vision-list.show').removeClass('show');
					}
				});
			}

			//Header map for admin
			const data = {
				action: 'sitemap',
			};
			$.ajax({
				url: ajaxurl,
				data,
				type: 'POST',
				success(responce) {
					const res = JSON.parse(responce);
					if (responce && res !== '') {
						$('.header').append(res);
					}
				},
			});
		},

		gutenbergAccordeonScript() {
			$('.accordion-header').click(function (e) {
				e.preventDefault();

				const $this = $(this);

				if ($this.next().hasClass('show')) {
					$this.next().removeClass('show');
					$this.removeClass('show');
					$this.next().slideUp(450);
				} else {
					$this
						.parent()
						.parent()
						.find('.accordion-content')
						.removeClass('show');
					$this.parent().parent().find('.accordion-content').slideUp(450);
					if (
						$this.parent().parent().find('.accordion-item').not($this.next())
					) {
						$this
							.parent()
							.parent()
							.find('.accordion-header')
							.removeClass('show');
					}
					$this.next().toggleClass('show');
					$this.toggleClass('show');
					$this.next().slideToggle(450);
				}
			});
		},

		dropdownMenu() {
			const Scrollbar = window.Scrollbar;
			$('.menu-header .sub-menu-wrap').each(function () {
				if ($(this).get(0).scrollHeight > 330) {
					$(this).siblings('.bottom-gradient').show();
					const scroll = Scrollbar.init($(this)[0], {
						continuousScrolling: false,
					});
					scroll.addListener(() => {
						MKIP_Scripts._menuGradient($(this));
					});
				}
			});
			$('.menu-mobile .sub-menu-wrap').each(function () {
				if ($(this).get(0).scrollHeight > 330) {
					$(this).siblings('.bottom-gradient').show();
					const scroll = Scrollbar.init($(this)[0]);
					scroll.addListener(() => {
						MKIP_Scripts._menuGradient($(this));
					});
				}
			});
		},

		_menuGradient(subMenu) {
			const content = subMenu.find('.scroll-content');
			const wrapper = subMenu;
			const contentBottom = content.offset().top + content.get(0).scrollHeight;
			const wrapperBottom = wrapper.offset().top + wrapper.outerHeight();
			const topGradient = subMenu.siblings('.top-gradient');
			const bottomGradient = subMenu.siblings('.bottom-gradient');
			topGradient.show();
			bottomGradient.show();
			if (content.offset().top == wrapper.offset().top) {
				topGradient.hide();
			} else if (contentBottom == wrapperBottom) {
				bottomGradient.hide();
			}
		},

		careerMenu() {
			if ($('.career-pages ul li') && $(window).width() < 1023) {
				$('.career-pages ul li').click(function () {
					$(this).toggleClass('active');
				});

				$(document).click(function (e) {
					if ($(e.target).parents('.career-pages').length === 0) {
						$('.career-pages ul li.active').removeClass('active');
					}
				});
			}
		},

		filtersType() {
			const filterTypesItem = $('.filter-types-item');
			filterTypesItem.click(function () {
				filterTypesItem.removeClass('active');
				$(this).addClass('active');
				MKIP_Scripts._getFiltersPosts($);
			});
		},

		filters() {
			const Scrollbar = window.Scrollbar;
			Scrollbar.init($('.filters-dropdown__wrap')[0]);
			$('.filter__list').each(function () {
				Scrollbar.init($(this)[0]);
			});

			$(document).click(function (e) {
				if (
					!e.target.classList.contains('filters-dropdown') &&
					!e.target.closest('.filters-dropdown') &&
					!$(e.target).hasClass('filters-btn') &&
					$(e.target).parents('.daterangepicker').length === 0 &&
					$(e.target).parents('.table-condensed').length === 0
				) {
					$('.filters-dropdown').slideUp();
					$('.filters').removeClass('filters-open');
				}
			});

			const dateFilter = $('#filter-date');
			if (dateFilter.length) {
				MKIP_Scripts._datePicker();
			}

			$('.filters-btn').click(function () {
				$('.filters').toggleClass('filters-open');
				//if($(".filters").hasClass("filters-open")){
				$('.filters-dropdown').slideToggle();
				//} else{
				//  $(".filters-dropdown").slideUp();
				//}
			});

			const filter = $('.filter');
			const filterBtn = $('.filter__title--text');
			const applyBtn = $('.filters-applay');

			filterBtn.click(function () {
				if ($(this).hasClass('active')) {
					$(this).closest('.filter').removeClass('filter-open');
					$(this).removeClass('active');
				} else {
					filter.removeClass('filter-open');
					filterBtn.removeClass('active');
					$(this).closest('.filter').addClass('filter-open');
					$(this).addClass('active');
				}
			});

			const filterItem = $('.filter-item');
			filterItem.click(function () {
				if ($(this).hasClass('active')) {
					$(this).removeClass('active');
				} else {
					$(this).addClass('active');
				}
				setControlBtnStatus();
				setFilterResetBtnStatus($(this));
			});

			const resetFilterBtn = $('.filter__title-reset');
			resetFilterBtn.click(function () {
				$(this)
					.parents('.filter')
					.find('.filter-item.active')
					.removeClass('active');
				$(this).parents('.filter').removeClass('reset-btn-active');
				//MKIP_Scripts._getFiltersPosts( $ );
				setControlBtnStatus();
				setFilterResetBtnStatus();
			});

			const resetFiltersBtn = $('.filters-reset');
			resetFiltersBtn.click(function () {
				if ($(this).hasClass('active')) {
					filterItem.each(function () {
						$(this).removeClass('active');
					});
					filter.each(function () {
						$(this).removeClass('reset-btn-active');
					});
				}

				if ($('#filter-date') && $('#filter-date').length > 0) {
					$('#filter-date').attr('data-first', '');
					$('#filter-date').attr('data-last', '');
					$('#filter-date').data('daterangepicker').setStartDate(moment());
					$('#filter-date').data('daterangepicker').setEndDate(moment());
				}
				MKIP_Scripts._getFiltersPosts($);
				setControlBtnStatus();
				setFilterResetBtnStatus();
				$('.filters').removeClass('filters-open');
				$('.filters-dropdown').slideUp();
			});

			applyBtn.click(function () {
				if (applyBtn.hasClass('active')) {
					MKIP_Scripts._getFiltersPosts($);
					setControlBtnStatus();
					setFilterResetBtnStatus();
					$('.filters').removeClass('filters-open');
					$('.filters-dropdown').slideUp();
				}
			});

			function setControlBtnStatus() {
				if (
					$('.filter-item.active').length > 0 ||
					$('#filter-date').attr('data-first') ||
					window.location.search
				) {
					$('.filters-reset').addClass('active');
					$('.filters-applay').addClass('active');
				} else {
					$('.filters-reset').removeClass('active');
					$('.filters-applay').removeClass('active');
				}
			}

			function setFilterResetBtnStatus(thisItem) {
				const filterContainer = $(thisItem).parents('.filter');
				const selected = $(filterContainer).find('.filter-item.active');
				if (selected.length > 0) {
					$(filterContainer).addClass('reset-btn-active');
				} else {
					$(filterContainer).removeClass('reset-btn-active');
				}

				if ($('.filter-item.active').length > 0) {
					$('.filters').addClass('checked');
				} else {
					$('.filters').removeClass('checked');
				}
			}

			window.addEventListener('popstate', function () {
				window.location.reload();
			});
		},

		_datePicker() {
			const dateFilter = $('#filter-date');

			const langArray = {
				en: {
					daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
					monthNames: [
						'January',
						'February',
						'March',
						'April',
						'May',
						'June',
						'July',
						'August',
						'September',
						'October',
						'November',
						'December',
					],
					btn: ['Cancel', 'Apply'],
				},
				uk: {
					daysOfWeek: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
					monthNames: [
						'Січень',
						'Лютий',
						'Березень',
						'Квітень',
						'Травень',
						'Червень',
						'Липень',
						'Серпень',
						'Вересень',
						'Жовтень',
						'Листопад',
						'Грудень',
					],
					btn: ['Скинути', 'Обрати'],
				},
			};

			dateFilter.daterangepicker({
				startDate: dateFilter.attr('data-first')
					? dateFilter.attr('data-first')
					: moment(),
				endDate: dateFilter.attr('data-last')
					? dateFilter.attr('data-last')
					: moment(),
				autoUpdateInput: true,
				autoApply: true,
				locale: {
					format: 'YYYY-MM-DD',
					cancelLabel: langArray[lang].btn[0],
					applyLabel: langArray[lang].btn[1],
					daysOfWeek: langArray[lang].daysOfWeek,
					monthNames: langArray[lang].monthNames,
				},
				alwaysShowCalendars: true,
				showCustomRangeLabel: false,
				showDropdowns: true,
				minYear: 1990,
				maxYear: 2050,
				parentEl: '.filter-date__wrap',
				linkedCalendars: false,
			});
			$('.date-cancel').click(() => {
				dateFilter.attr('data-first', '');
				dateFilter.attr('data-last', '');
				dateFilter.data('daterangepicker').setStartDate(moment());
				dateFilter.data('daterangepicker').setEndDate(moment());
				$('td').removeClass('active');
				$('td').removeClass('in-range');
			});
			dateFilter.on('cancel.daterangepicker', function () {
				$(this).attr('data-first', '');
				$(this).attr('data-last', '');
				$(this).data('daterangepicker').setStartDate(moment());
				$(this).data('daterangepicker').setEndDate(moment());

				if ($('.filter-item.active').length > 0) {
					$('.filters-reset').addClass('active');
					$('.filters-applay').addClass('active');
				} else {
					$('.filters-reset').removeClass('active');
					$('.filters-applay').removeClass('active');
				}
			});
			dateFilter.on('apply.daterangepicker', function (_e, picker) {
				$(this).attr('data-first', picker.startDate.format('YYYY-MM-DD'));
				$(this).attr('data-last', picker.endDate.format('YYYY-MM-DD'));
				$('.filters-applay').addClass('active');
				$('.filters-reset').addClass('active');
				$('.filters').addClass('checked');
			});
		},

		_getFiltersPosts() {
			let param = '';
			let parameters = '';
			const filterParams = MKIP_Scripts._getFilterParams($);
			let postType = $('.filters').data('type');
			let lang = $('.filters').data('lang');
			if ($('.filter-types').length) {
				postType = $('.filter-types').data('type');
				lang = $('.filter-types').data('lang');
			}
			let rubricSlug = '';

			if (postType === 'news') {
				rubricSlug = 'news-rubric';
			}
			if (postType === 'events') {
				rubricSlug = 'events-rubric';
			}
			if (postType === 'press-releases') {
				rubricSlug = 'press-releases-rubric';
			}
			if (postType === 'announcements') {
				rubricSlug = 'announcements-rubric';
			}

			if (lang === 'uk') {
				lang = '';
			} else {
				lang = '/' + lang;
			}

			if (filterParams.rubric.length && filterParams.rubric[0] !== 'all') {
				param += '&' + rubricSlug + '=' + filterParams.rubric;
			}

			if (filterParams.activity.length && filterParams.activity[0] !== 'all') {
				param += '&field-of-activity=' + filterParams.activity;
			}

			if (filterParams.region.length && filterParams.region[0] !== 'all') {
				param += '&announcements-region=' + filterParams.region;
			}

			if (filterParams.type.length && filterParams.type[0] !== 'all') {
				param += '&gallery-type=' + filterParams.type;
			}

			if (filterParams.start.length && filterParams.start !== 'all') {
				param += '&date-start=' + filterParams.start;
			}

			if (filterParams.end.length && filterParams.end !== 'all') {
				param += '&date-end=' + filterParams.end;
			}

			if (param.length) {
				parameters = '?' + param.slice(1);
			}
			history.pushState(
				'',
				'',
				window.location.origin + lang + '/' + postType + '/' + parameters
			);

			const data = {
				action: 'archive_filters',
				postType,
				language: lang ? lang : 'uk',
				rubric: filterParams.rubric,
				activity: filterParams.activity,
				region: filterParams.region,
				type: filterParams.type,
				start: filterParams.start,
				end: filterParams.end,
				urlParam: parameters,
			};

			$.ajax({
				url: ajaxurl,
				data,
				type: 'POST',
				beforeSend() {
					$('.loader-wrap').removeClass('hide');
					MKIP_Scripts.playFilterLoader(true);
				},
				complete() {
					$('.loader-wrap').addClass('hide');
					MKIP_Scripts.playFilterLoader(false);
				},
				success(responce) {
					const res = JSON.parse(responce);
					if (res.posts !== '') {
						$('.posts-section__wrap').html(res.posts);
					}
					$('.pagination').html(res.pagination);
				},
			});
		},

		playFilterLoader(isVisible) {
			const container = document.getElementById('loader-wrap__player');
			const animation = lottie.loadAnimation({
				container,
				path:
					'https://' +
					document.location.host +
					'/wp-content/themes/mkip-2022/img/preloader.json',
				loop: true,
				autoplay: false,
			});

			if (isVisible) {
				if (!document.getElementById('loader-wrap__player').hasChildNodes()) {
					animation.play();
				}
			} else {
				animation.destroy();
			}
		},

		showLoader() {
			function getCookie(c_name) {
				let c_value = document.cookie,
					c_start = c_value.indexOf(' ' + c_name + '=');
				if (c_start == -1) {
					c_start = c_value.indexOf(c_name + '=');
				}
				if (c_start == -1) {
					c_value = null;
				} else {
					c_start = c_value.indexOf('=', c_start) + 1;
					let c_end = c_value.indexOf(';', c_start);
					if (c_end == -1) {
						c_end = c_value.length;
					}
					c_value = unescape(c_value.substring(c_start, c_end));
				}
				return c_value;
			}
			const langCode = $('body').data('lang') ? $('body').data('lang') : 'uk';

			const container = document.getElementById('loader');
			const animation = lottie.loadAnimation({
				container,
				path:
					'https://' +
					document.location.host +
					'/wp-content/themes/mkip-2022/img/preloader_' +
					langCode +
					'.json',
				loop: true,
				autoplay: true,
				rendererSettings: {
					progressiveLoad: true,
					preserveAspectRatio: 'xMidYMid meet',
					imagePreserveAspectRatio: 'xMidYMid meet',
				},
			});
			animation.play();
		},

		hideLoader() {
			//animation.destroy();
			setTimeout(function () {
				$('.body-loader').removeClass('show');
				$('.body-loader').addClass('hide'); //.fadeOut();
			}, 2000);
		},

		_getFilterParams() {
			const filterParam = [];
			filterParam.rubric = [];
			filterParam.activity = [];
			filterParam.region = [];
			filterParam.type = [];
			filterParam.start = '';
			filterParam.end = '';

			if ($('#filter-date').attr('data-first')) {
				filterParam.start = $('#filter-date').attr('data-first');
			}
			if ($('#filter-date').attr('data-last')) {
				filterParam.end = $('#filter-date').attr('data-last');
			}

			$('.filter-item.active').each(function () {
				if ($(this).data('rubric')) {
					filterParam.rubric.push($(this).data('rubric'));
				}
				if ($(this).data('region')) {
					filterParam.region.push($(this).data('region'));
				}
				if ($(this).data('activity')) {
					filterParam.activity.push($(this).data('activity'));
				}
			});

			$('.filter-types-item.active').each(function () {
				if ($(this).data('type')) {
					filterParam.type.push($(this).data('type'));
				}
			});
			return filterParam;
		},

		homeSliders() {
			const newsSlider = jQuery('.main-news-slider__list');
			if (newsSlider.length) {
				newsSlider.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					lazyLoad: 'ondemand',
					arrows: true,
					dots: false,
					infinite: false,
					cssEase: 'linear',
					appendArrows: '.main-news-slider__nav',
					prevArrow:
						'<div class="slider-nav__item slider-nav__item--prev"><svg><use xlink:href="#arrow-left"></use></svg></div>',
					nextArrow:
						'<div class="slider-nav__item slider-nav__item--next"><svg><use xlink:href="#arrow-right"></use></svg></div>',
					responsive: [
						{
							breakpoint: 1366,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 1,
							},
						},
					],
				});
			}

			const areasSlider = jQuery('.areas-of-activity__list');
			if (areasSlider.length) {
				areasSlider.slick({
					slidesToShow: 4,
					slidesToScroll: 1,
					lazyLoad: 'ondemand',
					arrows: true,
					dots: false,
					infinite: false,
					cssEase: 'linear',
					appendArrows: '.areas-of-activity__nav',
					prevArrow:
						'<div class="slider-nav__item slider-nav__item--prev"><svg><use xlink:href="#arrow-left"></use></svg></div>',
					nextArrow:
						'<div class="slider-nav__item slider-nav__item--next"><svg><use xlink:href="#arrow-right"></use></svg></div>',
					swipeToSlide: true,
					responsive: [
						{
							breakpoint: 1366,
							settings: {
								slidesToShow: 3,
							},
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 1,
							},
						},
					],
				});
			}

			const projectsSlider = jQuery('.main-projects__list');
			if (projectsSlider.length) {
				projectsSlider.slick({
					slidesToShow: 2,
					slidesToScroll: 1,
					lazyLoad: 'ondemand',
					arrows: true,
					dots: false,
					infinite: false,
					cssEase: 'linear',
					appendArrows: '.main-projects__nav',
					prevArrow:
						'<div class="slider-nav__item slider-nav__item--prev"><svg><use xlink:href="#arrow-left"></use></svg></div>',
					nextArrow:
						'<div class="slider-nav__item slider-nav__item--next"><svg><use xlink:href="#arrow-right"></use></svg></div>',
				});
			}

			const subscriptionSlider = $('.main-subscription__slider');
			if (subscriptionSlider.length) {
				subscriptionSlider.slick({
					infinite: true,
					arrows: false,
					dots: false,
					autoplay: true,
					autoplaySpeed: 5000,
					fade: true,
					cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
				});
			}
		},

		gallery() {
			const gallerySliderBottom = jQuery('.gallery-slider-bottom');
			const gallerySliderTop = jQuery('.gallery-slider-top');

			if (gallerySliderBottom.length && gallerySliderTop.length) {
				const galleryThumbs = new Swiper('.gallery-slider-bottom', {
					spaceBetween: 0,
					slidesPerView: 5,
					touchRatio: 0.2,
					slideToClickedSlide: true,
					height: 'auto',
				});

				const _galleryTop = new Swiper('.gallery-slider-top', {
					spaceBetween: 10,
					slidesPerView: 1,
					navigation: {
						nextEl: '.gallery-top-nav--next',
						prevEl: '.gallery-top-nav--prev',
					},
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					loop: true,
					//loopedSlides: 4,
					thumbs: {
						swiper: galleryThumbs,
						slideThumbActiveClass: 'slick-center',
					},
				});

				lightGallery(document.getElementById('gallery-slider-top'), {
					selector: '.swiper-slide.gallery-slider-top__item',
				});
			}
		},

		subscriptionValidForm() {
			const invalidClassName = 'invalid';
			const inputs = document.querySelectorAll('.subscription__input');
			inputs.forEach(function (input) {
				input.addEventListener('invalid', function () {
					input.classList.add(invalidClassName);
				});
				input.addEventListener('input', function () {
					if (input.validity.valid) {
						input.classList.remove(invalidClassName);
					}
				});
			});
		},

		accordeon() {
			$('.structural-subdivisions__hide-link').click(function () {
				$(this).toggleClass('open');
				$('.structural-subdivisions').toggleClass('open');
			});
		},

		institutionsAccordeon() {
			$('.institutions-item__expand-btn').click(function () {
				$(this).toggleClass('open');
				$(this).parents('.institutions-item').toggleClass('open');
			});
		},

		institutionsFilters() {
			//white shadow in region filter
			function _scrollShadowControl() {
				const content = document.querySelector('.institutions-filter__list'),
					wrapper = document.querySelector(
						'.institutions-sidebar__filter-wrap'
					),
					shadowTop = document.querySelector('.shadow--top'),
					shadowBottom = document.querySelector('.shadow--bottom'),
					contentScrollHeight = content.scrollHeight - wrapper.offsetHeight;

				content.addEventListener('scroll', function () {
					const currentScroll = this.scrollTop / contentScrollHeight;
					shadowTop.style.opacity = currentScroll;
					shadowBottom.style.opacity = 1 - currentScroll;
				});
			}
			//scrollShadowControl();

			//height dropdown filter on mobile
			$('.institutions-sidebar__title--mobile').click(function () {
				$('.institutions-sidebar__filter').toggleClass('filters-open');
				$('.institutions-sidebar__title--mobile').toggleClass('open');
				$('body').toggleClass('filters-open');

				if ($(window).width() < 1024) {
					const top = $('.institutions-sidebar__filter').offset().top;
					const windowHeight = document.body.clientHeight;
					if ($('.institutions-sidebar__filter').hasClass('filters-open')) {
						$('.institutions-sidebar__filter').height(windowHeight - top);
					} else {
						$('.institutions-sidebar__filter').height('');
					}
				}

				//scrollShadowControl();
			});

			//sticky sidebar on desktop
			function stickySidebar() {
				if ($(window).width() > 1023) {
					const stickyEl = new Sticksy('.sticksy-wrap', {
						topSpacing: 100,
						listen: true,
					});
					stickyEl.onStateChanged = function (state) {
						if (state === 'fixed') {
							stickyEl.nodeRef.classList.add('widget--sticky');
						} else {
							stickyEl.nodeRef.classList.remove('widget--sticky');
						}
					};
				}
			}

			stickySidebar();

			//filter logic
			const regionFilterItem = $('.filter-item');
			regionFilterItem.click(function () {
				regionFilterItem.removeClass('active');
				$(this).addClass('active');
				getInstitutionsFiltersPosts();
				if ($('.institutions-sidebar__filter').hasClass('filters-open')) {
					$('.institutions-sidebar__filter').removeClass('filters-open');
					$('body').removeClass('filters-open');
					$('.institutions-sidebar__filter').height('');
				}
			});

			const typeFilterItem = $('.filter-type-item');
			typeFilterItem.click(function () {
				typeFilterItem.removeClass('active');
				$(this).addClass('active');
				getInstitutionsFiltersPosts();
			});

			function getInstitutionsFiltersPosts() {
				let param = '';
				let parameters = '';
				const filterParams = getInstitutionsFilterParams();
				const postType = 'institutions';
				let lang = $('.institutions-sidebar__filter').data('lang');

				if (lang == 'uk') {
					lang = '';
				} else {
					lang = '/' + lang;
				}

				if (filterParams.region.length && filterParams.region[0] !== 'all') {
					param += '&institutions-region=' + filterParams.region;
				}

				if (filterParams.type.length && filterParams.type[0] !== 'all') {
					param += '&type-of-institutions=' + filterParams.type;
				}

				if (param.length) {
					parameters = '?' + param.slice(1);
				}
				history.pushState(
					'',
					'',
					window.location.origin + lang + '/' + postType + '/' + parameters
				);

				const data = {
					action: 'archive_filters',
					postType,
					region: filterParams.region,
					type: filterParams.type,
					urlParam: parameters,
					language: lang ? lang : 'uk',
				};

				$.ajax({
					url: ajaxurl,
					data,
					type: 'POST',
					beforeSend() {
						$('.loader-wrap').removeClass('hide');
						MKIP_Scripts.playFilterLoader(true);
					},
					complete() {
						$('.loader-wrap').addClass('hide');
						MKIP_Scripts.playFilterLoader(false);
						//stickySidebar();
					},
					success(responce) {
						const res = JSON.parse(responce);
						if (res.posts !== '') {
							$('.institutions-posts-section__wrap').html(res.posts);
							MKIP_Scripts.institutionsAccordeon();
						}
						$('.pagination').html(res.pagination);
					},
				});
			}

			function getInstitutionsFilterParams() {
				const filterParam = [];
				filterParam.region = [];
				filterParam.type = [];

				$('.filter-item.active').each(function () {
					filterParam.region.push($(this).data('region'));
				});

				$('.filter-type-item.active').each(function () {
					filterParam.type.push($(this).data('type'));
				});
				return filterParam;
			}
		},

		legislationFilters() {
			//height dropdown filter on mobile
			$('.legislation-sidebar__title--mobile').click(function () {
				$('.legislation-sidebar__filter').toggleClass('filters-open');
				$('.legislation-sidebar__title--mobile').toggleClass('open');
				$('body').toggleClass('filters-open');

				if ($(window).width() < 1024) {
					const top = $('.legislation-sidebar__filter').offset().top;
					const windowHeight = document.body.clientHeight;
					if ($('.legislation-sidebar__filter').hasClass('filters-open')) {
						$('.legislation-sidebar__filter').height(windowHeight - top);
					} else {
						$('.legislation-sidebar__filter').height('');
					}
				}
			});

			//sticky sidebar on desktop
			function stickySidebar() {
				if ($(window).width() > 1023) {
					const stickyEl = new Sticksy('.sticksy-wrap', {
						topSpacing: 100,
						listen: true,
					});
					stickyEl.onStateChanged = function (state) {
						if (state === 'fixed') {
							stickyEl.nodeRef.classList.add('widget--sticky');
						} else {
							stickyEl.nodeRef.classList.remove('widget--sticky');
						}
					};
				}
			}

			stickySidebar();

			//filter logic
			const regionFilterItem = $('.filter-item');
			regionFilterItem.click(function () {
				regionFilterItem.removeClass('active');
				$(this).addClass('active');
				getLegislationFiltersPosts();
				if ($('.legislation-sidebar__filter').hasClass('filters-open')) {
					$('.legislation-sidebar__filter').removeClass('filters-open');
					$('body').removeClass('filters-open');
					$('.legislation-sidebar__filter').height('');
				}
			});
			$('.legislation-search-form__submit').click(function () {
				getLegislationFiltersPosts();
				if ($('.legislation-sidebar__filter').hasClass('filters-open')) {
					$('.legislation-sidebar__filter').removeClass('filters-open');
					$('body').removeClass('filters-open');
					$('.legislation-sidebar__filter').height('');
				}
				if ($('.legislation-search-form__input').val() !== '') {
					$('.legislation-search-form__cancel').addClass('active');
				} else {
					$('.legislation-search-form__cancel').removeClass('active');
				}
			});
			$('.legislation-search-form__cancel').click(function () {
				$('.legislation-search-form__input').val('');
				getLegislationFiltersPosts();
				if ($('.legislation-sidebar__filter').hasClass('filters-open')) {
					$('.legislation-sidebar__filter').removeClass('filters-open');
					$('body').removeClass('filters-open');
					$('.legislation-sidebar__filter').height('');
				}
				$('.legislation-search-form__cancel').removeClass('active');
			});

			const typeFilterItem = $('.filter-type-item');
			typeFilterItem.click(function () {
				typeFilterItem.removeClass('active');
				$(this).addClass('active');
				getLegislationFiltersPosts();
			});

			function getLegislationFiltersPosts() {
				let param = '';
				let parameters = '';
				const filterParams = getLegislationFilterParams();
				const search_query = $('.legislation-search-form__input')
					.val()
					.toLowerCase();
				const postType = 'legislation';
				let lang = $('.legislation-sidebar__filter').data('lang');

				if (lang == 'uk') {
					lang = '';
				} else {
					lang = '/' + lang;
				}

				if (filterParams.type.length && filterParams.type[0] !== 'all') {
					param += '&legislation-type=' + filterParams.type;
				}

				if (filterParams.years.length && filterParams.years[0] !== 'all') {
					param += '&years=' + filterParams.years;
				}
				if (search_query && search_query !== '') {
					param += '&search=' + search_query;
				}

				if (param.length) {
					parameters = '?' + param.slice(1);
				}
				history.pushState(
					'',
					'',
					window.location.origin + lang + '/' + postType + '/' + parameters
				);

				const data = {
					action: 'legislation_filters',
					postType,
					type: filterParams.type,
					years: filterParams.years,
					search: search_query,
					urlParam: parameters,
					language: lang ? lang : 'uk',
				};

				$.ajax({
					url: ajaxurl,
					data,
					type: 'POST',
					beforeSend() {
						$('.loader-wrap').removeClass('hide');
						MKIP_Scripts.playFilterLoader(true);
					},
					complete() {
						$('.loader-wrap').addClass('hide');
						MKIP_Scripts.playFilterLoader(false);
						//stickySidebar();
					},
					success(responce) {
						const res = JSON.parse(responce);
						if (res.posts !== '') {
							$('.legislation-posts-section__wrap').html(res.posts);
						}
						$('.pagination').html(res.pagination);
						
						if (res.type_counts) {
							for (let typeSlug in res.type_counts) {
								if (res.type_counts.hasOwnProperty(typeSlug)) {
									$(`.filter-item[data-region="${typeSlug}"] .${typeSlug}`).text(`(${res.type_counts[typeSlug]})`);
								}
							}
						}
					},
				});
			}

			function getLegislationFilterParams() {
				const filterParam = [];
				filterParam.type = [];
				filterParam.years = [];

				$('.filter-item.active').each(function () {
					filterParam.type.push($(this).data('region'));
				});

				$('.filter-type-item.active').each(function () {
					filterParam.years.push($(this).data('type'));
				});
				return filterParam;
			}
		},

		consultAccordeon() {
			$('.consult-block__header-wrap').click(function () {
				$(this).toggleClass('open');
				$(this).find('.consult-block__expand-btn').toggleClass('open');
				$(this).parents('.consult-block__item').toggleClass('open');
			});
		},

		actsAccordeon() {
			$('.accordion__header-wrap').click(function () {
				const $this = $(this);
				$this.toggleClass('open');
				$this.find('.accordion__expand-btn').toggleClass('open');
				$this.parents('.accordion__item').toggleClass('open');
				$this.next('.accordion__expanded-wrap').slideToggle();
			});
			$('.accordion__subtitle').click(function () {
				const $this = $(this);
				$this.toggleClass('open');
				$this.parents('.accordion__subitem').toggleClass('open');
				$this.next('.accordion__subitem--expanded-wrap').slideToggle();
			});
		},

		actsMenu() {
			$(document).ready(function () {
				$('.activity-page__sidebar .current-menu-ancestor').addClass('open');
			});

			$('.activity-page__sidebar .menu-item-has-children').click(function () {
				$(this).toggleClass('open');
			});

			$('.activity-page__sidebar .menu-item-has-children .sub-menu').click(
				function (e) {
					e.stopPropagation();
				}
			);
		},

		careerSlider() {
			const slider = jQuery('.slider-block__items');
			if (slider.length) {
				slider.slick({
					slidesToShow: 2,
					slidesToScroll: 1,
					lazyLoad: 'ondemand',
					arrows: true,
					dots: false,
					infinite: true,
					cssEase: 'linear',
					appendArrows: '.slider-block__nav',
					prevArrow:
						'<div class="slider-nav__item slider-nav__item--prev"><svg><use xlink:href="#arrow-left"></use></svg></div>',
					nextArrow:
						'<div class="slider-nav__item slider-nav__item--next"><svg><use xlink:href="#arrow-right"></use></svg></div>',
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
							},
						},
					],
				});
			}
		},

		careerPopup() {
			if ($('.region-select').length) {
				$('.region-select').select2({ minimumResultsForSearch: Infinity });
			}
			if ($('.city-select').length) {
				if ($('html[lang=uk]')) {
					$('.city-select').select2({
						minimumResultsForSearch: Infinity,
						placeholder: 'Куди готові переїхати',
					});
				} else {
					$('.city-select').select2({
						minimumResultsForSearch: Infinity,
						placeholder: 'Choose the cities to which you are ready to move',
					});
				}
			}
			$('.region-select').on(
				'select2:opening select2:closing',
				function (_event) {
					const $searchfield = $(this).parent().find('.select2-search__field');
					$searchfield.prop('disabled', true);
				}
			);
			$('.city-select').on(
				'select2:opening select2:closing',
				function (_event) {
					const $searchfield = $(this).parent().find('.select2-search__field');
					$searchfield.prop('disabled', true);
				}
			);

			$(document).click(function (e) {
				if (e.target.classList.contains('contact-popup__bg')) {
					//if(!container.is(e.target) && container.has(e.target).length === 0){
					$('.contact-popup__bg').removeClass('open');
					$('.contact-popup').removeClass('open');
					$('body').removeClass('popup-open');
					$('.contact-popup__form-wrap').removeClass('success');
				}
			});

			$('.respond-section__btn').click(function (e) {
				$('.contact-popup__bg').addClass('open');
				$('.contact-popup').addClass('open');
				$('body').addClass('popup-open');
				e.stopPropagation();
			});

			$('.contact-popup__close-btn').click(function (e) {
				$('.contact-popup').removeClass('open');
				$('.contact-popup__form-success').removeClass('active');
				setTimeout(function () {
					$('.contact-popup__bg').removeClass('open');
				}, 300);
				$('body').removeClass('popup-open');
				$('.contact-popup__form-wrap').removeClass('success');
				e.stopPropagation();
			});

			const labelVal = $('.cv-input__title').text();

			$("input[type='file']").on('change', function (e) {
				const fileName = e.target.value.split('\\').pop();

				if (fileName) {
					$(this).parents().find('.cv-input__title').text(fileName);
					$('.cv-input__hint').hide();
					$('.cv-input__reset').show();
				} else {
					$(this).parents().find('.cv-input__title').text(labelVal);
					$('.cv-input__hint').show();
					$('.cv-input__reset').hide();
				}
			});
			$('.cv-input__reset').on('click', function () {
				$(".cv-input input[type='file']").val('');
				$(this).parents().find('.cv-input__title').text(labelVal);
				$('.cv-input__hint').show();
				$('.cv-input__reset').hide();
			});

			$('.wpcf7-form-control-wrap').on('input', function () {
				$('.wpcf7-not-valid-tip', this).hide();
				$('input', this).attr('aria-invalid', 'false');
				$('textarea', this).attr('aria-invalid', 'false');
			});
		},

		careerFormSubmit() {
			const wpcf7Elm = document.querySelectorAll('.wpcf7');
			const success = $('.contact-popup__form-success');
			const formWrap = $('.contact-popup__form-wrap');
			if (wpcf7Elm) {
				wpcf7Elm.forEach(function (elem) {
					elem.addEventListener(
						'wpcf7mailsent',
						function () {
							success.addClass('active');
							formWrap.addClass('success');
							// setTimeout( function() {
							//   success.removeClass( "active" );
							//   formWrap.removeClass( "success" );
							//   $( ".contact-popup__bg" ).removeClass( "open" );
							//   $( ".contact-popup" ).removeClass( "open" );
							//   $( "body" ).removeClass( "popup-open" );
							// }, 5000 );
						},
						false
					);
				});
				$('.wpcf7-form').on('input', '.wpcf7-not-valid', function () {
					$(this).removeClass('wpcf7-not-valid');
				});
			}
		},

		contactPopup() {
			$(document).click(function (e) {
				if (e.target.classList.contains('contact-popup__bg')) {
					//if(!container.is(e.target) && container.has(e.target).length === 0){
					$('.contact-popup__bg').removeClass('open');
					$('.contact-popup').removeClass('open');
					$('body').removeClass('popup-open');
					$('.contact-popup__form-wrap').removeClass('success');
				}
			});

			$('.contact-form__link-ask').click(function (e) {
				$('.contact-popup__bg').addClass('open');
				$('.contact-popup__ask').addClass('open');
				$('body').addClass('popup-open');
				e.stopPropagation();
			});
			$('.contact-form__link-appeal').click(function (e) {
				$('.contact-popup__bg').addClass('open');
				$('.contact-popup__appeal').addClass('open');
				$('body').addClass('popup-open');
				e.stopPropagation();
			});
			$('.contact-popup__close-btn').click(function (e) {
				$('.contact-popup').removeClass('open');
				$('.contact-popup__form-success').removeClass('active');
				setTimeout(function () {
					$('.contact-popup__bg').removeClass('open');
				}, 300);
				$('body').removeClass('popup-open');
				$('.contact-popup__form-wrap').removeClass('success');
				e.stopPropagation();
			});

			$('.wpcf7-form-control-wrap').on('input', function () {
				$('.wpcf7-not-valid-tip', this).hide();
				$('input', this).attr('aria-invalid', 'false');
				$('textarea', this).attr('aria-invalid', 'false');
			});
		},

		contactFormSubmit() {
			const wpcf7Elm = document.querySelectorAll('.wpcf7');
			const success = $('.contact-popup__form-success');
			const formWrap = $('.contact-popup__form-wrap');
			if (wpcf7Elm) {
				wpcf7Elm.forEach(function (elem) {
					elem.addEventListener(
						'wpcf7mailsent',
						function () {
							success.addClass('active');
							formWrap.addClass('success');
							// setTimeout( function() {
							//   success.removeClass( 'active' );
							//   formWrap.removeClass( 'success' );
							//   $( '.contact-popup__bg' ).removeClass( 'open' );
							//   $( '.contact-popup' ).removeClass( 'open' );
							//   $( 'body' ).removeClass( 'popup-open' );
							// }, 5000 );
						},
						false
					);
				});
				$('.wpcf7-form').on('input', '.wpcf7-not-valid', function () {
					$(this).removeClass('wpcf7-not-valid');
				});
			}
		},

		corruptionForm() {
			$(document).click(function (e) {
				if (e.target.classList.contains('contact-popup__bg')) {
					//if(!container.is(e.target) && container.has(e.target).length === 0){
					$('.contact-popup__bg').removeClass('open');
					$('.contact-popup').removeClass('open');
					$('body').removeClass('popup-open');
					$('.contact-popup__form-wrap').removeClass('success');
				}
			});

			$('.corruption-form__btn').click(function (e) {
				$(this).toggleClass('open');
				$('.corruption-form').slideToggle();
				e.stopPropagation();
			});

			$('.contact-popup__close-btn').click(function (e) {
				$('.contact-popup').removeClass('open');
				$('.contact-popup__form-success').removeClass('active');
				setTimeout(function () {
					$('.contact-popup__bg').removeClass('open');
				}, 300);
				$('body').removeClass('popup-open');
				$('.contact-popup__form-wrap').removeClass('success');
				e.stopPropagation();
			});

			$('.wpcf7-form-control-wrap').on('input', function () {
				$('.wpcf7-not-valid-tip', this).hide();
				$('input', this).attr('aria-invalid', 'false');
				$('textarea', this).attr('aria-invalid', 'false');
			});
		},

		corruptionFormSubmit() {
			const wpcf7Elm = document.querySelectorAll('.wpcf7');
			const success = $('.contact-popup__form-success');
			const formWrap = $('.contact-popup__form-wrap');
			if (wpcf7Elm) {
				wpcf7Elm.forEach(function (elem) {
					elem.addEventListener(
						'wpcf7mailsent',
						function () {
							success.addClass('active');
							formWrap.addClass('success');
							$('.contact-popup').addClass('open');
							$('.contact-popup__bg').addClass('open');
							// setTimeout( function() {
							//   success.removeClass( "active" );
							//   formWrap.removeClass( "success" );
							//   $( ".contact-popup__bg" ).removeClass( "open" );
							//   $( ".contact-popup" ).removeClass( "open" );
							//   $( "body" ).removeClass( "popup-open" );
							// }, 5000 );
						},
						false
					);
				});
				$('.wpcf7-form').on('input', '.wpcf7-not-valid', function () {
					$(this).removeClass('wpcf7-not-valid');
				});
			}
		},

		careerLoadMore() {
			const loadMoreBtn = jQuery('.vacancies-block__load-btn');
			const lang = $('body').data('lang');
			loadMoreBtn.click(function () {
				MKIP_Scripts.careerCurrentPage++;

				const filterType = [];
				$('.job-filter-types-item.active').each(function () {
					if ($(this).data('type')) {
						filterType.push($(this).data('type'));
					}
				});

				const data = {
					action: 'load_more_vacancies',
					postType: 'vacancies',
					page: MKIP_Scripts.careerCurrentPage,
					type: filterType,
					language: lang ? lang : 'uk',
					//urlParam: parameters,
				};

				$.ajax({
					url: ajaxurl,
					data,
					type: 'POST',
					beforeSend() {
						$('.loader-wrap').removeClass('hide');
						MKIP_Scripts.playFilterLoader(true);
					},
					complete() {
						$('.loader-wrap').addClass('hide');
						MKIP_Scripts.playFilterLoader(false);
					},
					success(responce) {
						const res = JSON.parse(responce);
						if (res.posts !== '') {
							$('.vacancies-block__items').append(res.posts);
						}
						if (MKIP_Scripts.careerCurrentPage >= res.max) {
							$('.vacancies-block__load-btn').hide();
						} else {
							$('.vacancies-block__load-btn').show();
						}
					},
				});
			});
		},

		jobType() {
			const filterTypesItem = $('.job-filter-types-item');
			filterTypesItem.click(function () {
				filterTypesItem.removeClass('active');
				$(this).addClass('active');
				MKIP_Scripts.careerCurrentPage = 1;

				const filterType = [];
				const postType = $('.job-filter-types').data('type');
				const lang = $('.job-filter-types').data('lang');
				let param = '';
				let parameters = '';

				$('.job-filter-types-item.active').each(function () {
					if ($(this).data('type')) {
						filterType.push($(this).data('type'));
					}
				});

				if (filterType.length && filterType[0] !== 'all') {
					param += '&job-type=' + filterType;
				}

				if (param.length) {
					parameters = '?' + param.slice(1);
				}
				history.pushState(
					'',
					'',
					window.location.origin + window.location.pathname + parameters
				);
				const data = {
					action: 'vacancies_filters',
					type: filterType,
					urlParam: parameters,
					language: lang ? lang : 'uk',
				};

				$.ajax({
					url: ajaxurl,
					data,
					type: 'POST',
					beforeSend() {
						$('.loader-wrap').removeClass('hide');
						MKIP_Scripts.playFilterLoader(true);
					},
					complete() {
						$('.loader-wrap').addClass('hide');
						MKIP_Scripts.playFilterLoader(false);
					},
					success(responce) {
						const res = JSON.parse(responce);
						if (res.posts !== '') {
							$('.vacancies-block__items').html(res.posts);
						}

						if (MKIP_Scripts.careerCurrentPage >= res.max) {
							$('.vacancies-block__load-btn').hide();
						} else {
							$('.vacancies-block__load-btn').show();
						}
					},
				});
			});
		},

		careerAnnouncementsLoadMore() {
			const loadMoreBtn = jQuery('.career-announcements__load-btn');
			loadMoreBtn.click(function () {
				MKIP_Scripts.careerAnnouncementsCurrentPage++;

				const currentBtn = $(this);

				const filterParams = {};
				filterParams.field = [];
				filterParams.rubric = [];
				filterParams.exclude = [];

				if ($(this).data('type')) {
					filterParams.field.push($(this).data('type'));
				}
				if ($(this).data('rubric')) {
					filterParams.rubric.push($(this).data('rubric'));
				}
				if ($(this).data('exclude')) {
					filterParams.exclude.push($(this).data('exclude'));
				}

				const data = {
					action: 'load_more_career_announcements',
					postType: 'career-announcements',
					page: MKIP_Scripts.careerAnnouncementsCurrentPage,
					type: filterParams.field,
					rubric: filterParams.rubric,
					exclude: filterParams.exclude,
				};

				$.ajax({
					url: ajaxurl,
					data,
					type: 'POST',
					beforeSend() {
						$('.loader-wrap').removeClass('hide');
						MKIP_Scripts.playFilterLoader(true);
					},
					complete() {
						$('.loader-wrap').addClass('hide');
						MKIP_Scripts.playFilterLoader(false);
					},
					success(responce) {
						const res = JSON.parse(responce);
						if (res.posts !== '') {
							$(currentBtn)
								.parent()
								.parent()
								.find('.press-releases-list')
								.append(res.posts);
						}
						if (MKIP_Scripts.careerAnnouncementsCurrentPage >= res.max) {
							$(currentBtn).hide();
						} else {
							$(currentBtn).show();
						}
					},
				});
			});
		},

		numberCounter() {
			$(function () {
				$(window).scroll(startCounter);
			});
			function spaceSeparateNumber(num) {
				return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
			}

			function startCounter() {
				const scrollY =
					(window.pageYOffset || document.documentElement.scrollTop) +
					window.innerHeight;
				const containerPos =
					document.querySelector('.indicators-block').offsetTop;

				if (scrollY > containerPos) {
					$(window).off('scroll', startCounter);
					$('.numscroller').each(function () {
						const $this = $(this);
						$({
							countNum: 0,
						}).animate(
							{
								countNum: $this.text().replace(/\D/g, ''),
							},
							{
								duration: 2000,
								easing: 'linear',
								step() {
									$this.text(spaceSeparateNumber(Math.floor(this.countNum)));
								},
								complete() {
									$this.text(spaceSeparateNumber(this.countNum));
								},
							}
						);
					});
				}
			}
		},

		mobileSidebar() {
			$('.sidebar__mobile-btn').click(function () {
				$('.sidebar__mobile').toggleClass('open');
				$(this).toggleClass('open');
				$('body').toggleClass('sidebar-open');
			});
		},

		competitionsAccordeon() {
			$('.art-competitions__title').click(function () {
				const $this = $(this);
				$this.parent().toggleClass('open');
				//$this.parent().next(".art-competitions__content-wrap").toggleClass("open");
				$this.parent().next('.art-competitions__content-wrap').slideToggle();
			});
		},

		artCompetitionPopup() {
			$(document).click(function (e) {
				if (e.target.classList.contains('contact-popup__bg')) {
					//if(!container.is(e.target) && container.has(e.target).length === 0){
					$('.contact-popup__bg').removeClass('open');
					$('.contact-popup').removeClass('open');
					$('body').removeClass('popup-open');
					$('.contact-popup__form-wrap').removeClass('success');
				}
			});

			$('.respond-section__btn').click(function (e) {
				$('.contact-popup__bg').addClass('open');
				$('.contact-popup').addClass('open');
				$('body').addClass('popup-open');
				e.stopPropagation();
			});
			$('.contact-popup__close-btn').click(function (e) {
				$('.contact-popup').removeClass('open');
				$('.contact-popup__form-success').removeClass('active');
				setTimeout(function () {
					$('.contact-popup__bg').removeClass('open');
				}, 300);
				$('body').removeClass('popup-open');
				$('.contact-popup__form-wrap').removeClass('success');
				e.stopPropagation();
			});

			const fileInput = $('.file-input');
			fileInput.each(function () {
				const self = $(this);
				const labelVal = $(self).find('.documents-input__title').text();

				$(self)
					.find("input[type='file']")
					.on('change', function (e) {
						const fileName = e.target.value.split('\\').pop();

						if (fileName) {
							$(self).find('.documents-input__title').text(fileName);
							$(self).find('.documents-input__title').addClass('added');
						} else {
							$(this).parents().find('.documents-input__title').text(labelVal);
							$(this)
								.parents()
								.find('.documents-input__title')
								.removeClass('added');
						}
					});
				$(self).on('click', function (e) {
					if ($(self).find('.documents-input__title').hasClass('added')) {
						e.preventDefault();
						$(self).find('.documents-input__title').removeClass('added');
						$(self).find("input[type='file']").val('');
						$(self).find('.documents-input__title').text(labelVal);
					}
				});
			});

			$('.tooltip-btn').click(function (e) {
				e.preventDefault();
				// 	$( '.tooltiptext' ).toggleClass( 'open' );
			});

			tippy('.tooltip', {
				allowHTML: true,
				content: reference => reference.querySelector('.tooltiptext'),
				maxWidth: 700,
			});
		},

		artCompetitionFormSubmit() {
			const wpcf7Elm = document.querySelectorAll('.wpcf7');
			const success = $('.contact-popup__form-success');
			const formWrap = $('.contact-popup__form-wrap');
			if (wpcf7Elm) {
				wpcf7Elm.forEach(function (elem) {
					elem.addEventListener(
						'wpcf7mailsent',
						function () {
							success.addClass('active');
							formWrap.addClass('success');
							// setTimeout( function() {
							//   success.removeClass( "active" );
							//   formWrap.removeClass( "success" );
							//   $( ".contact-popup__bg" ).removeClass( "open" );
							//   $( ".contact-popup" ).removeClass( "open" );
							//   $( "body" ).removeClass( "popup-open" );
							// }, 5000 );
						},
						false
					);
				});
				$('.wpcf7-form').on('input', '.wpcf7-not-valid', function () {
					$(this).removeClass('wpcf7-not-valid');
				});
			}
		},

		taskPopup() {
			$(document).click(function (e) {
				if (e.target.classList.contains('popup__bg')) {
					//if(!container.is(e.target) && container.has(e.target).length === 0){
					$('.popup__bg').removeClass('open');
					$('.popup').removeClass('open');
					$('body').removeClass('popup-open');
					$('.popup__form-wrap').removeClass('success');
				}
			});

			$('.structural-subdivisions-item__tasks-btn').click(function (e) {
				$(this).toggleClass('open');
				const currentIndex = $(this).data('popup');
				const currentPopup = $(
					`.structural-subdivisions-popup[data-popup= ${currentIndex}]`
				);

				currentPopup.addClass('open');
				currentPopup.find('.popup__bg').addClass('open');
				e.stopPropagation();
			});

			$('.popup__close-btn').click(function (e) {
				$('.popup').removeClass('open');
				setTimeout(function () {
					$('.popup__bg').removeClass('open');
				}, 300);
				$('body').removeClass('popup-open');
				e.stopPropagation();
			});
		},

		findInAccordeon() {
			const urlParams = new URLSearchParams(window.location.search);
			const searchword = urlParams.get('s');
			const cards = $('.accordion__expanded-content li');

			function searchOnPage() {
				const search_query = $('.accordion-search-form__input')
					.val()
					.toLowerCase();

				for (let i = 0; i < cards.length; i++) {
					const cardText = cards[i].textContent.toLowerCase();

					const searchTerms = search_query.split(' ');

					const allTermsFound = searchTerms.every(term =>
						cardText.includes(term)
					);

					if (allTermsFound) {
						cards[i].classList.remove('is-hidden');
					} else {
						cards[i].classList.add('is-hidden');
					}
				}
				if ($('html[lang=uk]')) {
					$('.accordion__search-result').html('Не знайдено');
					$('.accordion__expanded-content').each(function () {
						const liCount = $(this).find('li:not(.is-hidden)').length;
						$(this)
							.parent()
							.parent()
							.find('.accordion__search-result')
							.html(`Знайдено <b>${liCount}</b>`);
					});
				} else {
					$('.accordion__search-result').html('Not found');
					$('.accordion__expanded-content').each(function () {
						const liCount = $(this).find('li:not(.is-hidden)').length;
						$(this)
							.parent()
							.parent()
							.find('.accordion__search-result')
							.html(`Founded <b>${liCount}</b>`);
					});
				}
			}

			if (searchword) {
				$(window).on('load', function () {
					$('html, body').animate(
						{
							scrollTop: $('.accordion-search-form__input').offset().top - 100,
						},
						450
					);
				});
				searchOnPage();
			}

			$('.accordion-search-form__input').keyup(function () {
				searchOnPage();

				if ($('.highlight').length > 0) {
					$('.highlight').removeClass('highlight');
				}
			});
		},

		highlightString() {
			const urlParams = new URLSearchParams(window.location.search);
			let searchword = false;
			if (urlParams.get('s')) {
				searchword = urlParams.get('s');
			}
			const regEx = new RegExp(searchword, 'ig');

			if (searchword) {
				$('.article-content').each(function () {
					$(this).html(
						$(this)
							.html()
							.replace(/&nbsp;/g, ' ')
					);

					function processTextNodes(element) {
						if (element.nodeType === 3) {
							const textContent = $(element).text();
							const highlightedContent = textContent.replace(
								regEx,
								"<span class='highlight'>$&</span>"
							);
							$(element).replaceWith(highlightedContent);
						} else if (element.nodeType === 1) {
							$(element)
								.contents()
								.each(function () {
									processTextNodes(this);
								});
						}
					}

					processTextNodes(this);
				});

				if ($('.highlight').length) {
					$(window).on('load', function () {
						$('html, body').animate(
							{
								scrollTop: $('.highlight').offset().top - 100,
							},
							450
						);
					});
				}
			}
		},

		testBanner() {
			function setCookie(key, value, expiry) {
				const expires = new Date();
				expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
				document.cookie =
					key + '=' + value + '; path=/; expires=' + expires.toUTCString();
			}
			function getCookie(key) {
				const keyValue = document.cookie.match(
					'(^|;) ?' + key + '=([^;]*)(;|$)'
				);
				return keyValue ? keyValue[2] : null;
			}

			const block = $('#test-mode');
			const close = $('.main-test-banner__close');
			if (!getCookie('test-mode')) {
				block.show();
			}
			close.click(function () {
				block.hide();
				setCookie('test-mode', 1, '7');
			});
		},

		deferCaptchaCF7() {
			var captchaLoaded = false;

			//Load reCAPTCHA script when CF7 form field is focused
			$('.wpcf7-form input').on('focus', function () {
				// If we have loaded script once already, exit.
				if (captchaLoaded) {
					return;
				}

				// Variable Intialization
				console.log('========= reCAPTCHA script loading ========');

				var head = document.getElementsByTagName('head')[0];
				var recaptchaScript = document.createElement('script');
				var cf7script = document.createElement('script');

				var recaptchaKey = '6Ld29YIhAAAAAKE9dAUcViT86BNbkIt0XVKLHKJy';

				// Dynamically add Recaptcha Script
				recaptchaScript.type = 'text/javascript';
				recaptchaScript.src =
					'https://www.google.com/recaptcha/api.js?render=' +
					recaptchaKey +
					'&ver=3.0';

				// Dynamically add CF7 script
				cf7script.type = 'text/javascript';

				cf7script.text =
					"var wpcf7_recaptcha = {'sitekey': '" +
					recaptchaKey +
					'\', \'actions\':{\'homepage\':\'homepage\',\'contactform\':\'contactform\'}};  let addEventsAndStuff = (t) => { var e; wpcf7_recaptcha = { ...null !== (e = wpcf7_recaptcha) && void 0 !== e ? e : {} }; const c = wpcf7_recaptcha.sitekey, { homepage: n, contactform: a } = wpcf7_recaptcha.actions, o = t => { const { action: e, func: n, params: a } = t; grecaptcha.execute(c, { action: e }).then((t => { const c = new CustomEvent("wpcf7grecaptchaexecuted", { detail: { action: e, token: t } }); document.dispatchEvent(c) })).then((() => { "function" == typeof n && n(...a) })).catch((t => console.error(t))) }; if (grecaptcha.ready((() => { o({ action: n }) })), document.addEventListener("change", (t => { o({ action: a }) })), "undefined" != typeof wpcf7 && "function" == typeof wpcf7.submit) { const t = wpcf7.submit; wpcf7.submit = function(e) { let c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}; o({ action: a, func: t, params: [e, c] }) } } document.addEventListener("wpcf7grecaptchaexecuted", (t => { console.log(); const e = document.querySelectorAll(\'form.wpcf7-form input[name="_wpcf7_recaptcha_response"]\'); for (let c = 0; c < e.length; c++) e[c].setAttribute("value", t.detail.token) })) }; addEventsAndStuff();';

				// Add Recaptcha Script
				head.appendChild(recaptchaScript);

				// Add CF7 Script AFTER Recaptcha. Timeout ensures the loading sequence.
				setTimeout(function () {
					head.appendChild(cf7script);
				}, 200);

				//Set flag to only load once
				captchaLoaded = true;
			});
		},

		init() {
			MKIP_Scripts.varInit();
			MKIP_Scripts.varResize();
			MKIP_Scripts.headerFixed();
			MKIP_Scripts.headerScripts();
			MKIP_Scripts.dropdownMenu();
			MKIP_Scripts.careerMenu();
			MKIP_Scripts.gutenbergAccordeonScript();
			MKIP_Scripts.highlightString();
			MKIP_Scripts.testBanner();
			if ($('.home').length) {
				MKIP_Scripts.contactPopup();
				MKIP_Scripts.contactFormSubmit();
				MKIP_Scripts.homeSliders();
			}
			if ($('.filters').length) {
				MKIP_Scripts.filters();
			}
			if ($('.filter-types').length) {
				MKIP_Scripts.filtersType();
			}
			if ($('.page-template-page-team-php').length) {
				MKIP_Scripts.accordeon();
				MKIP_Scripts.taskPopup();
			}
			if ($('.post-type-archive-institutions').length) {
				MKIP_Scripts.institutionsFilters();
				MKIP_Scripts.institutionsAccordeon();
			}
			if ($('.post-type-archive-legislation').length) {
				MKIP_Scripts.legislationFilters();
			}
			if ($('.page-template-page-consult-php').length) {
				MKIP_Scripts.consultAccordeon();
			}
			if (
				$('.page-template-page-contacts-php').length ||
				$('.page-template-page-citizens-application-sidebar-php').length
			) {
				MKIP_Scripts.contactPopup();
				MKIP_Scripts.contactFormSubmit();
			}
			if ($('.page-template-page-report-corruption-php').length) {
				MKIP_Scripts.corruptionForm();
				MKIP_Scripts.corruptionFormSubmit();
			}
			if ($('.page-template-page-career-php').length) {
				MKIP_Scripts.careerSlider();
				MKIP_Scripts.careerLoadMore();
				MKIP_Scripts.jobType();
				MKIP_Scripts.numberCounter();
				MKIP_Scripts.careerPopup();
				MKIP_Scripts.careerFormSubmit();
			}
			if (
				$('.single-vacancies').length ||
				$('.single-career-announcements').length
			) {
				MKIP_Scripts.careerPopup();
				MKIP_Scripts.careerFormSubmit();
			}
			if (
				$('.page-template-page-announcements-php').length ||
				$('.page-template-page-legal-acts-php').length ||
				$('.page-template-page-events-php').length ||
				$('.page-template-page-news-php').length ||
				$('.page-template-page-activity-content-php').length ||
				$('.page-template-page-projects-php').length ||
				$('.page-template-page-content-sidebar-php').length ||
				$('.page-template-page-schedule-sidebar-php').length ||
				$('.page-template-page-accordeon-php').length ||
				$('.page-template-page-accordeon-sidebar-php').length ||
				$('.page-template-page-administrative-services-php').length ||
				$('.page-template-page-citizens-application-sidebar-php').length
			) {
				MKIP_Scripts.actsMenu();
			}
			if (
				$('.page-template-page-announcements-php').length ||
				$('.page-template-page-events-php').length ||
				$('.page-template-page-news-php').length ||
				$('.page-template-page-activity-content-php').length ||
				$('.page-template-page-projects-php').length ||
				$('.page-template-page-content-sidebar-php').length ||
				$('.page-template-page-schedule-sidebar-php').length ||
				$('.page-template-page-legal-acts-php').length ||
				$('.page-template-page-accordeon-sidebar-php').length ||
				$('.page-template-page-administrative-services-php').length ||
				$('.page-template-page-citizens-application-sidebar-php').length
			) {
				MKIP_Scripts.mobileSidebar();
			}
			if (
				$('.page-template-page-accordeon-php').length ||
				$('.page-template-page-legal-acts-php').length ||
				$('.page-template-page-accordeon-sidebar-php').length ||
				$('.page-template-page-citizens-application-sidebar-php').length ||
				$('.page-template-page-public-consultations-php').length ||
				$('.page-template-page-public-procurement-php').length
			) {
				MKIP_Scripts.actsAccordeon();
			}
			if ($('.page-template-page-art-competitions-php').length) {
				MKIP_Scripts.competitionsAccordeon();
			}
			if (
				$('.single-announcements').length &&
				$('.art-competitions-respond').length
			) {
				MKIP_Scripts.artCompetitionPopup();
				MKIP_Scripts.artCompetitionFormSubmit();
			}
			if (
				$('.page-template-page-career-competitions-directors-php').length ||
				$('.page-template-page-career-competitions-service-php').length ||
				$('.page-template-page-career-competitions-contracts-php').length
			) {
				MKIP_Scripts.competitionsAccordeon();
				MKIP_Scripts.careerAnnouncementsLoadMore();
			}
			if (
				$('.page-template-page-accordeon-php').length ||
				$('.page-template-page-public-consultations-php').length
			) {
				MKIP_Scripts.findInAccordeon();
			}
			MKIP_Scripts.gallery();
			MKIP_Scripts.subscriptionValidForm();
		},
	};
	if ($('.home').length) {
		MKIP_Scripts.showLoader();
	}

	$(window).resize(function () {
		MKIP_Scripts.varResize();
		MKIP_Scripts.dropdownMenu();
		MKIP_Scripts.careerMenu();
	});

	$(document).ready(function () {
		MKIP_Scripts.init();
		MKIP_Scripts.hideLoader();
		MKIP_Scripts.deferCaptchaCF7();
	});

	$(document).on('scroll', function () {
		MKIP_Scripts.headerFixed();
	});
});
